import { Injectable } from '@angular/core';
import { FileService } from '@api-client';
import { LepiEditorImageHandler, UploadedFile } from '@lepisode-ui/components';

@Injectable({ providedIn: 'root' })
export class ImageUploadService implements LepiEditorImageHandler {
  constructor(private readonly fileService: FileService) {}

  upload(file: File): Promise<{ url: string }> {
    return new Promise<{ url: string }>((resolve) => {
      this.fileService
        .fileControllerUpload({
          body: {
            file,
          },
        })
        .subscribe((res) => {
          resolve({
            url: res.url!,
          });
        });
    });
  }

  delete(url: string): Promise<void> {
    return new Promise<void>((resolve) => {
      this.fileService.fileControllerDelete({
        url,
      });
    });
  }
}

@Injectable({ providedIn: 'root' })
export class UploadService {
  constructor(private readonly fileService: FileService) {}

  async handleUpload(file: File): Promise<UploadedFile> {
    return await new Promise((resolve) => {
      this.fileService
        .fileControllerUpload({
          body: {
            file,
          },
        })
        .subscribe((res) => {
          resolve({
            filename: file.name,
            url: res.url!,
          });
        });
    });
  }

  async handleDelete(url: string): Promise<void> {
    return new Promise((resolve) => {
      this.fileService
        .fileControllerDelete({
          url,
        })
        .subscribe({
          next: () => {
            resolve();
          },
          error: () => {
            resolve();
          },
        });
    });
  }
}
